import { Box, Container } from '@mui/material';
import React, { Component } from 'react';
import { JobReport } from '../../JobReport';
import { JobProcessingBanner } from '../JobProcessingBanner';
import PageHeader from '../../common/PageHeader';
import { AdminPageDetails, PageDetails } from '../config';

class AutoUnassignmentReport extends Component {
  state = {
    id: 'diffMajorAutoUnassignmentReport',
    title: '',
    isLoading: false,
    //Cache to store job assignments
    jobUnassignments: {},
  };

  componentDidMount() {
    this.loadPageTitle();
  }

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === this.state.id);
    this.setState({
      title: page.title,
    });
  };

  //O(1) Add recordId and students to cache data
  addJobUnassignment = (recordId, students) => {
    const jobUnassignments = this.state.jobUnassignments;
    jobUnassignments[recordId] = students;
    this.setState({
      jobUnassignments,
    });
  };

  render() {
    const id = this.state.id;
    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PageHeader
              id={this.state.id}
              title={this.state.title}
              isSubPage
              pageConfig={{ ...PageDetails, ...AdminPageDetails }}
            />
            <JobProcessingBanner />

            <Box id={`${id}__box_wrapper`}>
              <JobReport id={id} widgetName="Different Major Students Unassigment Jobs Report" />
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AutoUnassignmentReport;
